import { useState, useEffect } from 'react';
import { apiCall } from '../api/axios';

export const useOrganization = () => {
  const [organization, setOrganization] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchOrganization();
  }, []);

  // Function to safely decode HTML entities using DOMParser
  const decodeHtmlEntities = (str) => {
    if (!str) return str;
    const parser = new DOMParser();
    const doc = parser.parseFromString(str, 'text/html');
    return doc.documentElement.textContent || str;
  };

  const fetchOrganization = async () => {
    setLoading(true);
    setError(null);
    
    try {
      const response = await apiCall.get('/api/organization');
      const data = response.data;
      
      // Decode HTML entities in logo URLs
      const decodedData = {
        ...data,
        logoUrl: decodeHtmlEntities(data.logoUrl),
        poLogoUrl: decodeHtmlEntities(data.poLogoUrl),
        invoiceLogoUrl: decodeHtmlEntities(data.invoiceLogoUrl)
      };
      
      setOrganization(decodedData);
    } catch (error) {
      setError(error.message);
      
      // Set default organization data if fetch fails
      setOrganization({
        branchName: 'Main Branch',
        companyName: 'AGMS Auto Garage',
        company: 'AGMS Auto Garage',
        email: 'info@agms.com',
        companyContact: '+1-234-567-8900',
        contact: '+1-234-567-8900',
        logoUrl: '',
        address: '123 Main Street',
        city: 'New York',
        country: 'USA',
        currency_code: 'AED'
      });
    } finally {
      setLoading(false);
    }
  };

  return { organization, loading, error, refetch: fetchOrganization };
};
